module.exports = __webpack_public_path__ + "img/imagen1.ad3d0c0a.png";